import {Component, Input, OnChanges, OnInit, SimpleChanges} from '@angular/core';
import { TargetingForm } from '@app/@core/advertising/campaign/advert/targeting-form';
import { Uuid } from '@shared/utils/uuid';
import {HydratedTargetingFilterOption} from "@app/@core/@models/network/network-data.model";
import {TranslateService} from "@ngx-translate/core";
import { FormControl } from '@angular/forms';
import {
  ProductData
} from '@app/campaigns/campaign/@common/campaign-drafting/product-selection/product-data-helper.service';

@Component({
  selector: 'app-custom-group-targeting-options[hydratedTargetingFilterOptions][productData][targetingForm]',
  templateUrl: './custom-group-targeting-options.component.html',
  styleUrls: ['./custom-group-targeting-options.component.scss']
})
export class CustomGroupTargetingOptionsComponent implements OnInit, OnChanges {
  @Input() hydratedTargetingFilterOptions: HydratedTargetingFilterOption[] = [];
  @Input() productData!: ProductData;
  @Input() targetingForm!: TargetingForm;
  @Input() translationKey!: string;
  @Input() hideBorder = false;
  siteUrls: Array<string> = [];
  showSites = false;
  options: { controlIndex: number, name: string, description?: string, popoverTitle?: string, popoverDescription?: string }[] = [];
  uuid: string = Uuid.generate();
  showAllControl = new FormControl(false);

  constructor(private translateService: TranslateService) { }

  ngOnInit(): void {
    this.showAllControl.valueChanges.subscribe(checked => {
      console.log('swapout', checked);
      this.showSites = !!checked;
    });


    console.log(this.productData.siteGroupsAndSites);
    if (this.productData && this.productData.siteGroupsAndSites && this.productData.siteGroupsAndSites.length > 0) {
      this.productData.siteGroupsAndSites.forEach((sgAndSite) => {
        sgAndSite.sites.forEach((site) => {
          if (site.siteUrl) {
            this.siteUrls.push(this.deriveUrl(site.siteUrl));
          }
        });
      });
    }
  }

  ngOnChanges(changes: SimpleChanges): void {
    this.options = [];
    for (let i = 0; i < this.targetingForm.controls.customGroupTargets.length; i++) {
      const filterOption = this.getHydratedTargetingFilteringOption(i);
      if (filterOption) {
        const key = 'campaign.customGroups.' + filterOption.lineItemTemplate?.id;
        const instant = this.translateService.instant(key);
        const hasDescription = key !== instant;
        this.options.push({ controlIndex: i, name: filterOption.value, description: filterOption.description, popoverTitle: hasDescription ? filterOption.value : "", popoverDescription: hasDescription ? instant : "" });
      }
    }
    this.options.sort((a,b) => a.name.localeCompare(b.name));
  }

  private deriveUrl(rawUrl: string): string {
    const theUrl = new URL(rawUrl);
    const url = theUrl.host + theUrl.pathname;
    return url.endsWith('/') ? url.substring(0, url.length - 1) : url;
  }

  selectedCustomGroup(): string[] {
    const result: string[] = [];
    this.options.forEach(option => {
      if (this.targetingForm.value.customGroupTargets![option.controlIndex]) {
        result.push(option.name);
      }
    });
    return result;
  }

  private getHydratedTargetingFilteringOption(index: number): HydratedTargetingFilterOption | undefined {
    if (this.hydratedTargetingFilterOptions && index < this.hydratedTargetingFilterOptions.length) {
      return this.hydratedTargetingFilterOptions[index];
    }
    return undefined;
  }
}
